<template>
  <div class="aj-tree-tab" :style="{ '--bgColor': color }">
    <div class="aj-radio-tree-group flex-wrap" >
      <div v-for="item in optionList" :key="item.subValue" class="aj-radio-item" :class="activeValue == item.subValue ? 'aj-radio-item-active' : ''"  @click="changeRadio(item.subValue)">{{ item.showValue }}</div>
    </div>
    <!-- <infineRadio v-model="childValue" v-if="nextList.length > 0" :optionList="nextList" :tabIndex="tabIndex + 1" :hasAll="hasAll" :tabLabel="tabLabel" :tabValue="tabValue" :tabChild="tabChild" :color="color" @change="change"></infineRadio> -->
  </div>
</template>

<script>
// import infineTab from './infineTab.vue';
export default {
  name: 'infineRadio',
  props: {
    tabLabel: {
      type: String,
      default: 'label'
    },
    tabValue: {
      type: String,
      default: 'value'
    },
    tabChild: {
      type: String,
      default: 'children'
    },
    color: {
      type: String,
      default: '#3775ff'
    },
    optionList: {
      type: Array,
      default: () => []
    },
    tabIndex: {
      type: Number,
      default: 0
    },
    hasAll: {
      type: String,
      default: null
    },
    checkOut: {
      type: Boolean,
      default: false
    },
    flexWrap:{
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeValue: ''
    };
  },
  methods: {

    changeRadio(data) {
      console.log('data',data)
      this.activeValue = data
      this.$emit('select', this.activeValue);
      this.$emit('input', this.activeValue);
          this.$emit('change', this.activeValue);
    },
  
    del () {
      this.activeValue = ''
    }
  }

 
};
</script>

<style lang="scss" scoped>
.aj-tree-tab {
  width: 100%;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  // display: flex;
  .aj-radio-tree-group {
    display: flex;
    .aj-radio-item {
      // margin-left: 0;
      flex-shrink: 0;
      margin-bottom: 0.5rem;
      margin-right: 0.5rem;
      background-color: rgb(224, 232, 246);
      line-height: none;
      padding: 0.3rem 1rem;
      border-radius: 0.9rem;
      font-size: 0.8rem;
      line-height: normal;
    }
    .aj-radio-item-active {
      background-color: #3775ff;
      color: #fff;
    }
  }
  .flex-wrap{
    flex-wrap: wrap;
  }
}
</style>
